"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_MESSAGES = exports.MESSAGES = void 0;
// Bot text messages in Uzbek
exports.MESSAGES = {
    // Start & Welcome
    WELCOME: `🚗 *Moshina Bozor*ga xush kelibsiz!

Bu yerda siz o'z mashinangizni osongina sotishingiz mumkin.

Boshlash uchun quyidagi tugmalardan birini tanlang:`,
    // Main Menu
    MENU_SELL: '🚗 Mashina sotish',
    MENU_MY_ADS: '📋 Mening e\'lonlarim',
    MENU_HELP: '❓ Yordam',
    MENU_SETTINGS: '⚙️ Sozlamalar',
    // Sell Flow - Images
    UPLOAD_IMAGES: `📸 *Rasm yuklash*

Iltimos, mashinangizning rasmlarini yuboring.

• Kamida 1 ta, ko'pi bilan 4 ta rasm yuklashingiz mumkin
• Rasmlar sifatli bo'lishi kerak
• Mashina nomeringiz avtomatik yashiriladi

_Rasmlarni bitta-bitta yoki birdan bir nechta yuborishingiz mumkin._`,
    IMAGES_RECEIVED: (count) => `✅ ${count} ta rasm qabul qilindi.\n\nYana rasm qo'shish yoki davom etish uchun tugmani bosing.`,
    IMAGES_LIMIT: '⚠️ Ko\'pi bilan 4 ta rasm yuklash mumkin.',
    IMAGES_PROCESSING: '⏳ Rasmlar qayta ishlanmoqda...',
    IMAGES_READY: `✅ *Rasmlar tayyor!*

Yuqoridagi rasmlarni tekshiring. Mashina raqamlari yashirilgan va rasmlar birlashtirilgan.

Tasdiqlaysizmi?`,
    // Sell Flow - Data Collection
    CHOOSE_DATA_METHOD: `📝 *Ma'lumot kiritish*

Mashina haqida ma'lumotlarni qanday kiritmoqchisiz?`,
    METHOD_MINI_APP: '📱 Forma orqali (tavsiya)',
    METHOD_AUDIO: '🎤 Ovozli xabar orqali',
    AUDIO_INSTRUCTION: `🎤 *Ovozli xabar*

O'zbekcha gapirib, mashina haqida quyidagi ma'lumotlarni ayting:

• Markasi va modeli (masalan: Chevrolet Nexia)
• Ishlab chiqarilgan yili
• Narxi (dollar yoki so'm)
• Yurgan kilometri
• Yonilg'i turi (benzin, gaz, dizel)
• Korobka (mexanika yoki avtomat)
• Rangi
• Qayerda joylashgan
• Qo'shimcha ma'lumotlar

_Ovozli xabar yuboring:_`,
    AUDIO_PROCESSING: '⏳ Ovozli xabar tahlil qilinmoqda...',
    // Data Confirmation
    CONFIRM_DATA: (data) => {
        const brand = data.brand || 'Ko\'rsatilmagan';
        const model = data.model || '';
        const year = data.year || 'Ko\'rsatilmagan';
        const price = data.price || 'Ko\'rsatilmagan';
        // Currency translation
        let currency = '';
        if (data.currency === 'USD')
            currency = 'dollar';
        else if (data.currency === 'UZS')
            currency = 'so\'m';
        else
            currency = data.currency || '';
        const region = data.region || 'Ko\'rsatilmagan';
        const district = data.district ? `, ${data.district}` : '';
        // Fuel type translation
        let fuelType = 'Ko\'rsatilmagan';
        if (data.fuelType) {
            const fuelLower = data.fuelType.toLowerCase();
            if (fuelLower === 'petrol')
                fuelType = 'Benzin';
            else if (fuelLower === 'gas')
                fuelType = 'Gaz';
            else if (fuelLower === 'diesel')
                fuelType = 'Dizel';
            else if (fuelLower === 'hybrid')
                fuelType = 'Gibrid';
            else if (fuelLower === 'electric')
                fuelType = 'Elektr';
            else
                fuelType = data.fuelType;
        }
        // Transmission translation
        let transmission = 'Ko\'rsatilmagan';
        if (data.transmission) {
            const transLower = data.transmission.toLowerCase();
            if (transLower === 'automatic')
                transmission = 'Avtomat';
            else if (transLower === 'manual')
                transmission = 'Mexanika';
            else
                transmission = data.transmission;
        }
        const mileage = data.mileage || 'Ko\'rsatilmagan';
        const color = data.color || 'Ko\'rsatilmagan';
        const phone = data.contactPhone || data.phone || 'Ko\'rsatilmagan';
        const description = data.description || '';
        return `📋 *E'lon ma'lumotlari*

🚗 *Mashina:* ${brand} ${model}
📅 *Yili:* ${year}
💰 *Narxi:* ${price} ${currency}
📍 *Joylashuv:* ${region}${district}

⛽ *Yonilg'i:* ${fuelType}
⚙️ *Korobka:* ${transmission}
🛣 *Yurgan masofa:* ${mileage} km
🎨 *Rangi:* ${color}

📞 *Telefon:* ${phone}
${description ? `\n📝 *Qo'shimcha:* ${description}` : ''}

_Agar ma'lumotlar to'g'ri bo'lmasa, "Tahrirlash" tugmasini bosing._`;
    },
    DATA_CONFIRMED: '✅ Ma\'lumotlar tasdiqlandi!',
    // Payment
    PAYMENT_REQUIRED: (amount, card) => `💳 *To'lov*

E'lon joylashtirish narxi: *${amount} so'm*

To'lov uchun quyidagi kartaga pul o'tkazing:

\`${card}\`

To'lovdan so'ng, chek rasmini yuboring.`,
    PAYMENT_FREE: '🎉 Sizda bepul e\'lon imkoniyati bor! To\'lov talab qilinmaydi.',
    PAYMENT_PENDING: '⏳ To\'lovingiz tekshirilmoqda...',
    PAYMENT_CONFIRMED: '✅ To\'lov tasdiqlandi! E\'loningiz adminlarga yuborildi.',
    // Admin
    ADMIN_PENDING: '⏳ E\'loningiz adminlar tomonidan tekshirilmoqda. Tez orada javob beramiz.',
    ADMIN_APPROVED: '✅ E\'loningiz tasdiqlandi va guruhga joylashtirildi!',
    ADMIN_REJECTED: (reason) => `❌ E'loningiz rad etildi.\n\n📝 Sabab: ${reason}\n\nIltimos, tuzatib qaytadan yuboring.`,
    // Errors
    ERROR_GENERAL: '❌ Xatolik yuz berdi. Iltimos, qaytadan urinib ko\'ring.',
    ERROR_NOT_IMAGE: '❌ Iltimos, faqat rasm yuboring.',
    ERROR_IMAGE_TOO_SMALL: '❌ Rasm juda kichik. Kamida 800x600 piksel bo\'lishi kerak.',
    // Buttons
    BTN_CONFIRM: '✅ Tasdiqlash',
    BTN_CANCEL: '❌ Bekor qilish',
    BTN_BACK: '⬅️ Orqaga',
    BTN_CONTINUE: '➡️ Davom etish',
    BTN_ADD_MORE: '➕ Yana rasm qo\'shish',
    BTN_EDIT: '✏️ Tahrirlash',
    BTN_RETRY: '🔄 Qaytadan',
};
// Admin group message templates
exports.ADMIN_MESSAGES = {
    NEW_POST: (userId, username) => `🆕 *Yangi e'lon*\n\nFoydalanuvchi: @${username || userId}\nSana: ${new Date().toLocaleString('uz-UZ')}`,
    BTN_APPROVE: '✅ Tasdiqlash',
    BTN_REJECT: '❌ Rad etish',
    BTN_FREE_PASS: '🎁 Bepul ruxsat',
};
//# sourceMappingURL=messages.js.map